import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/service/[service]/ServicePage.js");
